var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { useGetCurrenciesQuery } from "@/store/api";
/** <b>Composant en mode consultation/detail d'un champ de type Currency</b>*/
export default function CurrencyFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    var dataList = useGetCurrenciesQuery(null).data;
    var currencyList = (dataList && dataList.data.currencies) || [];
    var defaultCurrency = currencyList.filter(function (currency) { return currency.id === record["currency_id"]; })[0];
    useEffect(function () { }, [record]);
    var value = useMemo(function () {
        if (!record) {
            return "";
        }
        return record[fieldName || ""] || "";
    }, [fieldName, record]);
    return (_jsx("span", __assign({ className: "flex items-center" }, { children: _jsxs("span", __assign({ className: "" }, { children: ["(", (defaultCurrency === null || defaultCurrency === void 0 ? void 0 : defaultCurrency.symbol) || "$", ") : ", value] })) })));
}
